
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","data-name":"oeamtc-icon__people","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.07 11.41c.45 1.34 3.2.45 3.2 3.59H3.73c0-3.13 2.75-2.25 3.2-3.59v-.9S6.1 9.72 6 9.18a.83.83 0 01-.44-.84c0-.35.17-.43.17-.43a2.19 2.19 0 01-.33-1.16A2.38 2.38 0 018 4.33a1.41 1.41 0 011.07.54c.92 0 1.46.83 1.46 1.93a2.8 2.8 0 01-.3 1.11s.17.06.17.43a1.09 1.09 0 01-.44.84c-.06.54-.89 1.33-.89 1.33v.9zM11.6 6.8a3 3 0 00-1.42-2.72 2.07 2.07 0 012.09-1.88 1.09 1.09 0 011.06.53c.81 0 1.07.9 1.07 1.87a2.41 2.41 0 01-.18.89c.08 0 .18.17.18.48a.77.77 0 01-.41.65 2.07 2.07 0 01-.66 1.18v.8c.4 1.2 2.67.4 2.67 3.2h-4.27c-.38-.23-1.31-.7-1.6-.83a4.55 4.55 0 001.34-2.63 1.75 1.75 0 00-.06-.48 3.34 3.34 0 00.19-1.06zm-5.73 4.14s-1.22.63-1.59.86H0C0 9.71 2.23 10.13 2.67 9v-.53C1.1 8.47.6 7.85.6 7.85c.81-.66-.72-5.12 2.07-5.12a1.22 1.22 0 01.85-.53A2.07 2.07 0 015.7 4a3.36 3.36 0 00-1.37 2.75 3.91 3.91 0 00.44 1.67 4 4 0 01-.5 0V9a1.29 1.29 0 00.73.69 4.49 4.49 0 00.86 1.25z"}})])
          )
        }
      }
    